import _ from 'lodash';
// @mui
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
//components
import { IfieldProps } from 'components/FormCreator/types';
import { useTheme, Box, Stack } from '@mui/material';

export interface radioProps {
	handleChange: any;
	options: { value: any; label: string; disabled?: boolean }[];
	value: any;
	label: string;
	name: string;
	disabled?: boolean;
}

export default function RadioSelector(props: radioProps) {
	const { value, options = [], handleChange, label, name } = props;
	const theme = useTheme();
	return (
		<FormControl fullWidth>
			<FormLabel sx={{ color: theme.palette.root.basicDeeoGreen }}>{label}</FormLabel>
			<Stack direction="row" spacing={1}>
				{options.map((option, i) => (
					<Box
						key={option.value + i}
						className="customRadioWrap"
						sx={{
							width: '50%',
							border: '1px solid #cbdcde',
							height: theme.sizes.INPUT_HIGHT + 'px',
							borderRadius: '8px',
							backgroundColor: _.isEqual(value, option.value)
								? theme.palette.root.brandSecondary_012
								: 'inherit',
							'& .MuiFormControlLabel-root': {
								margin: 'auto',
								height: 'inherit',
							},
							'& .MuiRadio-root': {
								[theme.breakpoints.down('sm')]: { padding: '4px' },
							},
						}}
					>
						<FormControlLabel
							name={name}
							key={option.value}
							value={option.value}
							control={
								<Radio
									disabled={option?.disabled}
									onClick={handleChange}
									name={name}
									checked={_.isEqual(value, option.value)}
								/>
							}
							label={option.label}
						/>
					</Box>
				))}
			</Stack>
		</FormControl>
	);
}
